import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const BilgiToplumu: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Bilgi Toplumu Hizmetleri' : 'Information Society Services'}</span>
    </>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Şirket Künyesi ve Bilgi Toplumu Hizmetleri' : 'Company Details & Information Society Services'}
        description={lang === 'tr' ? '5651 sayılı Kanun ve e-ticaret mevzuatı kapsamında şirketimize ait hizmet sağlayıcı bilgileri.' : 'Service provider information about our company under Law No. 5651 and e-commerce legislation.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Yasal Dayanak</h3>
                <p className="text-gray-700 leading-relaxed">Bu sayfa; 5651 sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi Hakkında Kanun ve Elektronik Ticaret Düzenlemesi Hakkında Kanun çerçevesinde, hizmet sağlayıcı bilgilerinin kamuoyuyla paylaşılması amacıyla hazırlanmıştır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Şirket Bilgileri</h3>
                <ul className="text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>Ticaret Unvanı:</strong> CG Yapay Zeka Teknoloji Yatırımları A.Ş.</li>
                  <li><strong>Kısa Adı:</strong> CG Teknoloji</li>
                  <li><strong>E-posta:</strong> info@cgteknoloji.com</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sunduğumuz Ürün ve Hizmetler</h3>
                <p className="text-gray-700 leading-relaxed mb-2">CG Teknoloji; başta uyum (compliance) teknolojileri olmak üzere aşağıdaki alanlarda ürün ve hizmet sunmaktadır:</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>UyumTakip</strong> — MASAK ve AML uyum yönetim yazılımı: müşteri tanıma (KYC), yaptırım/risk sorgulama, evrak ve işlem takibi</li>
                  <li>Finansal ve yükümlü sektörler için müşteri tanıma ve risk yönetimi çözümleri</li>
                  <li>Kurumsal yazılım geliştirme ve sistem entegrasyonu (banka, muhasebe)</li>
                  <li>Yapay zeka destekli iş süreçleri otomasyonu ve dinamik raporlama</li>
                  <li>Dijital dönüşüm danışmanlığı</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Uyuşmazlık Çözümü</h3>
                <p className="text-gray-700 leading-relaxed">Hizmetlerimize ilişkin uyuşmazlıklarda Türkiye Cumhuriyeti mahkemeleri ve ilgili Tüketici Hakem Heyetleri yetkilidir. Uyuşmazlık süreçlerinde Türk hukuku uygulanır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İletişim</h3>
                <p className="text-gray-700 leading-relaxed">Her türlü soru, öneri veya şikâyet için <strong>info@cgteknoloji.com</strong> adresinden bize ulaşabilirsiniz. Başvurular en kısa sürede yanıtlanacaktır.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Legal Basis</h3>
                <p className="text-gray-700 leading-relaxed">This page has been prepared within the framework of Law No. 5651 on the Regulation of Publications on the Internet and the Law on the Regulation of Electronic Commerce, for the purpose of sharing service provider information with the public.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Company Information</h3>
                <ul className="text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>Trade Name:</strong> CG Yapay Zeka Teknoloji Yatırımları A.Ş.</li>
                  <li><strong>Short Name:</strong> CG Teknoloji</li>
                  <li><strong>Email:</strong> info@cgteknoloji.com</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Our Products and Services</h3>
                <p className="text-gray-700 leading-relaxed mb-2">CG Teknoloji offers products and services in the following areas, primarily compliance technologies:</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>UyumTakip</strong> — MASAK and AML compliance management software: customer onboarding (KYC), sanctions/risk screening, document and transaction tracking</li>
                  <li>Customer onboarding and risk management solutions for financial and obliged sectors</li>
                  <li>Enterprise software development and system integration (bank, accounting)</li>
                  <li>AI-powered business process automation and dynamic reporting</li>
                  <li>Digital transformation consulting</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Dispute Resolution</h3>
                <p className="text-gray-700 leading-relaxed">The courts of the Republic of Turkey and the relevant Consumer Arbitration Committees are authorized for disputes regarding our services. Turkish law applies in dispute proceedings.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contact</h3>
                <p className="text-gray-700 leading-relaxed">For any questions, suggestions, or complaints, you can reach us at <strong>info@cgteknoloji.com</strong>. Applications will be answered as soon as possible.</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default BilgiToplumu; 